import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

/**
 * CMap options for PDFs with CID fonts (CJK etc.). cmaps version matches bundled pdfjs.
 */
export const PDF_DOCUMENT_OPTIONS = {
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
  cMapPacked: true,
};
